import axios from '../config/axiosConfig';

const API_URL = '/intruder';

const getAll = async (params = {}) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

const create = async (data) => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

const update = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}`, data);
  return response.data;
};

const start = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/start`);
  return response.data;
};

const getStatus = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/status`);
  return response.data;
};

const getResults = async (id, params = {}) => {
  const response = await axios.get(`${API_URL}/${id}/results`, { params });
  return response.data;
};

const pause = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/pause`);
  return response.data;
};

const cancel = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/cancel`);
  return response.data;
};

const remove = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

// Attack mode display configs
const attackModeConfig = {
  sniper: {
    label: 'Sniper',
    description: 'One payload set, one position at a time',
    icon: 'crosshairs'
  },
  battering_ram: {
    label: 'Battering Ram',
    description: 'Same payload in all positions simultaneously',
    icon: 'hammer'
  },
  pitchfork: {
    label: 'Pitchfork',
    description: 'N payload sets for N positions, iterated in parallel',
    icon: 'columns'
  },
  cluster_bomb: {
    label: 'Cluster Bomb',
    description: 'All combinations (cartesian product)',
    icon: 'bomb'
  }
};

const getAttackModeConfig = (mode) => attackModeConfig[mode] || attackModeConfig.sniper;

const intruderService = {
  getAll,
  getById,
  create,
  update,
  start,
  getStatus,
  getResults,
  pause,
  cancel,
  remove,
  attackModeConfig,
  getAttackModeConfig
};

export default intruderService;
